import constants from "../config/constants";
import firebase from "firebase/app";
import zapp from "../util/zapp";
import i18n from "../config/i18n";
import { EventBus } from "../util/event-bus";

const str_pad = function (str, pad_length, pad_string, pad_type) {
  let len = pad_length - str.length;
  if (len < 0) return str;

  let pad = new Array(len + 1).join(pad_string);
  if (pad_type === "STR_PAD_LEFT") return pad + str;

  return str + pad;
};

const getDailyStatisticsForDevices = function (
  devices,
  filters,
  labels,
  discardAcs
) {
  return new Promise((resolve) => {
    let devicesData = [];
    let index = 0;

    let stats = {
      consumption: labels.map(() => 0),
      temperature: labels.map(() => 0),
      temperature_probe: labels.map(() => 0),
      cost: labels.map(() => 0),
      saving: labels.map(() => 0),
    };

    function Resolve() {
      devicesData.forEach((device) => {
        //ENERGY
        if (device.energy) {
          let energyData = Object.values(device.energy);
          Object.keys(device.energy).forEach((deviceData, index) => {
            stats.consumption[parseInt(deviceData.substr(0, 2))] +=
              energyData[index].kw_h;
            stats.cost[parseInt(deviceData.substr(0, 2))] +=
              energyData[index].cost;
            stats.saving[parseInt(deviceData.substr(0, 2))] +=
              energyData[index].saving;
          });
        }

        //TEMPERATURE
        let temperatureData = Object.values(device.temperature);
        let chosen = [];

        Object.keys(device.temperature).forEach((deviceData, index) => {
          if (!chosen.includes(deviceData.substr(0, 2))) {
            if (temperatureData[index].temp !== undefined) {
              stats.temperature[parseInt(deviceData.substr(0, 2))] +=
                temperatureData[index].temp;
            }
            if (temperatureData[index].temp_probe !== undefined) {
              stats.temperature_probe[parseInt(deviceData.substr(0, 2))] +=
                temperatureData[index].temp_probe;
            }
          }
          chosen.push(deviceData.substr(0, 2));
        });
      });

      labels.forEach((hour, index) => {
        let devicesWithData = 0;
        devicesData.forEach((device) => {
          let hasData =
            Object.keys(device.temperature).filter((h) => {
              return (
                h.substr(0, 2) ===
                str_pad(hour.toString(), 2, "0", "STR_PAD_LEFT")
              );
            }).length > 0;

          if (hasData) devicesWithData++;
        });

        if (devicesWithData === 0) devicesWithData = 1;
        stats.temperature[index] = stats.temperature[index] / devicesWithData;
        stats.temperature_probe[index] =
          stats.temperature_probe[index] / devicesWithData;
      });

      resolve(stats);
    }

    devices.forEach(async (device) => {
      firebase
        .database()
        .ref("devices")
        .child(device)
        .child("data")
        .once(
          "value",
          (deviceSnapshot) => {
            let deviceData = deviceSnapshot.val();

            if (
              deviceData.mgmt_modules === undefined ||
              deviceData.mgmt_modules === 0
            ) {
              index++;

              if (index === devices.length) {
                Resolve();
              } else return;
            }

            firebase
              .database()
              .ref("history_statistics")
              .child(device)
              .child("daily")
              .child(filters.year)
              .child(filters.month)
              .child(filters.day)
              .once("value", (data) => {
                if (data.val() !== null) {
                  let d = data.val();

                  if (
                    deviceData.type === constants.deviceTypes.acs &&
                    discardAcs
                  )
                    d.temperature = {};
                  devicesData.push(d);
                }

                index++;
                if (index === devices.length) {
                  Resolve();
                }
              });
          },
          (error) => {
            index++;
            if (index === devices.length) {
              Resolve();
            }
          }
        );
    });
  });
};

const getMonthlyStatisticsForDevices = function (
  devices,
  filters,
  labels,
  discardAcs
) {
  return new Promise((resolve) => {
    let devicesData = {
      energy: [],
      temperature: [],
    };

    let index = 0;

    let stats = {
      consumption: labels.map(() => 0),
      temperature_min: labels.map(() => 0),
      temperature_max: labels.map(() => 0),
      temperature_min_probe: labels.map(() => 0),
      temperature_max_probe: labels.map(() => 0),
      cost: labels.map(() => 0),
      saving: labels.map(() => 0),
    };

    function Resolve() {
      //ENERGY
      devicesData.energy.forEach((device) => {
        let energyData = Object.values(device);
        Object.keys(device).forEach((deviceData, index) => {
          stats.consumption[deviceData - 1] += energyData[index].kw_h;
          stats.cost[deviceData - 1] += energyData[index].cost;
          stats.saving[deviceData - 1] += energyData[index].saving;
        });
      });

      //TEMPERATURE
      devicesData.temperature.forEach((device) => {
        let temperatureData = Object.values(device);
        let chosen = [];

        Object.keys(device).forEach((deviceData, index) => {
          if (!chosen.includes(deviceData.substr(0, 2))) {
            let min = temperatureData[index].temp_min;
            let min_probe = temperatureData[index].temp_probe_min;
            let max = temperatureData[index].temp_max;
            let max_probe = temperatureData[index].temp_probe_max;

            if (isNaN(min)) min = 0;
            if (isNaN(max)) max = 0;
            if (isNaN(min_probe)) min_probe = 0;
            if (isNaN(max_probe)) max_probe = 0;

            stats.temperature_min[deviceData - 1] += min;
            stats.temperature_min_probe[deviceData - 1] += min_probe;
            stats.temperature_max[deviceData - 1] += max;
            stats.temperature_max_probe[deviceData - 1] += max_probe;
          }

          chosen.push(deviceData.substr(0, 2));
        });
      });

      //TEMPERATURE AVERAGE
      labels.forEach((day, index) => {
        let devicesWithData = devicesData.temperature.filter((device) => {
          return (
            device[str_pad(day.toString(), 2, "0", "STR_PAD_LEFT")] !==
            undefined
          );
        }).length;

        if (devicesWithData === 0) devicesWithData = 1;

        stats.temperature_min[index] =
          stats.temperature_min[index] / devicesWithData;
        stats.temperature_min_probe[index] =
          stats.temperature_min_probe[index] / devicesWithData;
        stats.temperature_max[index] =
          stats.temperature_max[index] / devicesWithData;
        stats.temperature_max_probe[index] =
          stats.temperature_max_probe[index] / devicesWithData;
      });

      resolve(stats);
    }

    devices.forEach(async (device) => {
      firebase
        .database()
        .ref("devices")
        .child(device)
        .child("data")
        .once(
          "value",
          (deviceSnapshot) => {
            let deviceData = deviceSnapshot.val();

            if (
              deviceData.mgmt_modules === undefined ||
              deviceData.mgmt_modules === 0
            ) {
              index++;

              if (index === devices.length) {
                Resolve();
              } else return;
            }

            firebase
              .database()
              .ref("history_statistics")
              .child(device)
              .child("totals")
              .child("energy")
              .child(filters.year)
              .child(filters.month)
              .once("value", (data) => {
                if (data.val() !== null) devicesData.energy.push(data.val());

                firebase
                  .database()
                  .ref("history_statistics")
                  .child(device)
                  .child("totals")
                  .child("temperature")
                  .child(filters.year)
                  .child(filters.month)
                  .once("value", (data) => {
                    if (data.val() !== null) {
                      if (
                        deviceData.type !== constants.deviceTypes.acs ||
                        (deviceData.type === constants.deviceTypes.acs &&
                          !discardAcs)
                      )
                        devicesData.temperature.push(data.val());
                    }

                    index++;

                    if (index === devices.length) {
                      Resolve();
                    }
                  });
              });
          },
          (error) => {
            index++;

            if (index === devices.length) {
              Resolve();
            }
          }
        );
    });
  });
};

const getAnnualStatisticsForDevices = function (
  devices,
  filters,
  labels,
  discardAcs
) {
  return new Promise((resolve) => {
    let stats = {
      consumption: labels.map(() => 0),
      cost: labels.map(() => 0),
      saving: labels.map(() => 0),
      temperature_min: labels.map(() => 0),
      temperature_max: labels.map(() => 0),
      temperature_min_probe: labels.map(() => 0),
      temperature_max_probe: labels.map(() => 0),
    };

    let index = 0;

    for (let i = 0; i < 12; i++) {
      let d = new Date(filters.year, i + 1, 0);
      let monthLabels = zapp.range(1, d.getDate());
      let month = str_pad((i + 1).toString(), 2, "0", "STR_PAD_LEFT");

      getMonthlyStatisticsForDevices(
        devices,
        {
          month: month,
          year: filters.year,
        },
        monthLabels,
        discardAcs
      ).then((monthData) => {
        index++;

        stats.consumption[i] = monthData.consumption.reduce((a, b) => a + b, 0);
        stats.cost[i] = monthData.cost.reduce((a, b) => a + b, 0);
        stats.saving[i] = monthData.saving.reduce((a, b) => a + b, 0);

        //TEMPERATURES
        stats.temperature_min[i] = calculateMin(monthData.temperature_min);

        stats.temperature_min_probe[i] = calculateMin(
          monthData.temperature_min_probe
        );

        stats.temperature_max[i] = calculateMax(monthData.temperature_max);

        stats.temperature_max_probe[i] = calculateMax(
          monthData.temperature_max_probe
        );

        if (index === 12) {
          resolve(stats);
        }
      });
    }
  });
};

const calculateMax = function (max) {
  return Math.max(...max);
};

const calculateMin = function (min) {
  min = min.filter((item) => item !== 0);
  min = min.length > 0 ? min : [0];
  return Math.min(...min);
};

const getConsumptionStat = function (data, labels) {
  return {
    labels: labels,

    datasets: [
      {
        label: "kWh",
        data: data,
      },
    ],
  };
};

const getTemperatureStat = function (temp, temp_probe, labels) {
  return {
    labels: labels,
    datasets: [
      {
        label: i18n.t("statistics.temperature"),
        data: temp,
        backgroundColor: "white",
        pointStyle: "rect",
      },
      {
        borderColor: " rgba(255, 0, 0, 0.70)",
        label: i18n.t("statistics.temperature_probe"),
        data: temp_probe,
        backgroundColor: "red",
        pointStyle: "rect",
      },
    ],
  };
};

const getCostStat = function (data, labels, currency) {
  return {
    labels: labels,
    datasets: [
      {
        label: constants.currency[currency],
        data: data,
      },
    ],
  };
};

const getSavingStat = function (data, labels, currency) {
  return {
    labels: labels,
    datasets: [
      {
        fill: true,
        label: constants.currency[currency],
        data: data,
      },
    ],
  };
};

export default {
  namespaced: true,
  state: {
    data: null,
    quickSense: null,
    maxCost: null,
    maxCostStep: null,
  },
  mutations: {
    setData: function (state, data) {
      state.data = data;
    },

    setMaxCost: function (state, maxCost) {
      state.maxCost = maxCost;
    },

    setQuickSense: function (state, quickSense) {
      state.quickSense = quickSense;
    },

    setStep: function (state, step) {
      state.maxCostStep = step;
    },
  },
  actions: {
    setData(context, { devices, filters, discardAcs = false }) {
      return new Promise((resolve, reject) => {
        if (devices.length === 0) return reject();

        EventBus.$emit("showLoading");

        let stats = null;

        let labels = [];

        switch (filters.mode) {
          case constants.statisticsModes.daily:
            labels = zapp.range(0, 23);
            stats = getDailyStatisticsForDevices;
            break;
          case constants.statisticsModes.monthly:
            let d = new Date(filters.year, filters.month, 0);
            labels = zapp.range(1, d.getDate());
            stats = getMonthlyStatisticsForDevices;
            break;
          case constants.statisticsModes.annual:
            labels = constants.months;
            stats = getAnnualStatisticsForDevices;
            break;
        }

        stats(devices, filters, labels, discardAcs)
          .then((results) => {
            let data = {};
            data.consumption = getConsumptionStat(results.consumption, labels);
            data.cost = getCostStat(
              results.cost,
              labels,
              context.rootState.installations.current.currency
            );
            data.saving = getSavingStat(
              results.saving,
              labels,
              context.rootState.installations.current.currency
            );

            if (filters.mode === constants.statisticsModes.daily) {
              data.temperature = getTemperatureStat(
                results.temperature,
                results.temperature_probe,
                labels
              );
            } else {
              data.temperature_min = getTemperatureStat(
                results.temperature_min,
                results.temperature_min_probe,
                labels
              );
              data.temperature_max = getTemperatureStat(
                results.temperature_max,
                results.temperature_max_probe,
                labels
              );
            }

            context.commit("setData", data);
            EventBus.$emit("hideLoading");
            resolve();
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },

    setQuickSense(context, { devices, installation }) {
      return new Promise((resolve, reject) => {
        if (devices.length === 0) return reject();
        EventBus.$emit("showLoading");

        let today = new Date();

        firebase
          .database()
          .ref("kwh_tariff")
          .child(installation[".key"])
          .once("value", (tariff) => {
            let maxCost = 0;
            let rates = tariff.val();
            let deviceIndex = 0;

            let quickSense = {
              radiator: {
                consumption: 0,
                cost: 0,
                percentage: 0,
              },
              radiatorb: {
                consumption: 0,
                cost: 0,
                percentage: 0,
              },
              floor: {
                consumption: 0,
                cost: 0,
                percentage: 0,
              },
              therm: {
                consumption: 0,
                cost: 0,
                percentage: 0,
              },
              acs: {
                consumption: 0,
                cost: 0,
                percentage: 0,
              },
              towel: {
                consumption: 0,
                cost: 0,
                percentage: 0,
              },
              oval_towel: {
                consumption: 0,
                cost: 0,
                percentage: 0,
              },
              total: {
                consumption: 0,
                cost: 0,
              },
            };

            function resolve() {
              //GET PERCENTAGE
              if (quickSense.total.cost > 0) {
                quickSense.radiator.percentage =
                  (100 *
                    (quickSense.radiator.cost + quickSense.radiatorb.cost)) /
                  quickSense.total.cost;
                quickSense.floor.percentage =
                  (100 * quickSense.floor.cost) / quickSense.total.cost;
                quickSense.acs.percentage =
                  (100 * quickSense.acs.cost) / quickSense.total.cost;
                quickSense.towel.percentage =
                  (100 * (quickSense.towel.cost + quickSense.oval_towel.cost)) /
                  quickSense.total.cost;
                quickSense.therm.percentage =
                  (100 * quickSense.therm.cost) / quickSense.total.cost;
              }

              context.commit("setQuickSense", quickSense);

              let cost = Math.round(
                maxCost *
                  new Date(
                    today.getFullYear(),
                    today.getMonth() + 1,
                    0
                  ).getDate()
              );
              let power = String(parseInt(cost)).length - 2;
              let step = parseInt(Math.pow(10, parseFloat(power)));

              function roundValueForCostStep(value, step) {
                return Math.floor((value + step / 2) / step) * step;
              }

              cost =
                step > 0
                  ? parseFloat(
                      roundValueForCostStep(parseFloat(cost), parseFloat(step))
                    )
                  : 10;

              context.commit("setMaxCost", cost);
              context.commit("setStep", step);

              EventBus.$emit("hideLoading");
            }

            devices.forEach((device) => {
              firebase
                .database()
                .ref("devices")
                .child(device)
                .child("data")
                .once(
                  "value",
                  (deviceDataSnapshot) => {
                    let deviceData = deviceDataSnapshot.val();

                    if (
                      deviceData.mgmt_modules === undefined ||
                      deviceData.mgmt_modules === 0
                    ) {
                      deviceIndex++;
                      if (deviceIndex === devices.length) resolve();
                      else return;
                    }

                    if (deviceData.nominal_power !== undefined) {
                      rates.forEach((rate) => {
                        maxCost += (deviceData.nominal_power / 1000) * rate;
                      });
                    }

                    firebase
                      .database()
                      .ref("history_statistics")
                      .child(device)
                      .child("totals")
                      .child("energy")
                      .child(today.getFullYear())
                      .child(
                        (today.getMonth() + 1 < 10 ? "0" : "") +
                          (today.getMonth() + 1)
                      )
                      .once("value", (data) => {
                        let stats = data.val();

                        if (stats !== null) {
                          Object.values(stats).forEach((day) => {
                            //DEVICE TYPE
                            if (
                              deviceData.type ===
                              constants.deviceTypes.radiatorb
                            ) {
                              quickSense[
                                constants.deviceTypes.radiator
                              ].consumption += day.kw_h;
                              quickSense[constants.deviceTypes.radiator].cost +=
                                day.cost;
                            } else if (
                              deviceData.type ===
                              constants.deviceTypes.oval_towel
                            ) {
                              quickSense[
                                constants.deviceTypes.towel
                              ].consumption += day.kw_h;
                              quickSense[constants.deviceTypes.towel].cost +=
                                day.cost;
                            } else {
                              quickSense[deviceData.type].consumption +=
                                day.kw_h;
                              quickSense[deviceData.type].cost += day.cost;
                            }

                            //TOTAL
                            quickSense.total.consumption += day.kw_h;
                            quickSense.total.cost += day.cost;
                          });
                        }

                        deviceIndex++;
                        if (deviceIndex === devices.length) resolve();
                      });
                  },
                  (error) => {
                    deviceIndex++;
                    if (deviceIndex === devices.length) resolve();
                  }
                );
            });
          });

        resolve();
      });
    },
  },
};
